/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response model for formatted problem statement.
 * @export
 * @interface FormatStatementResponse
 */
export interface FormatStatementResponse {
    /**
     * 
     * @type {string}
     * @memberof FormatStatementResponse
     */
    formatted_html: string;
}

/**
 * Check if a given object implements the FormatStatementResponse interface.
 */
export function instanceOfFormatStatementResponse(value: object): value is FormatStatementResponse {
    if (!('formatted_html' in value) || value['formatted_html'] === undefined) return false;
    return true;
}

export function FormatStatementResponseFromJSON(json: any): FormatStatementResponse {
    return FormatStatementResponseFromJSONTyped(json, false);
}

export function FormatStatementResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormatStatementResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'formatted_html': json['formatted_html'],
    };
}

export function FormatStatementResponseToJSON(json: any): FormatStatementResponse {
    return FormatStatementResponseToJSONTyped(json, false);
}

export function FormatStatementResponseToJSONTyped(value?: FormatStatementResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'formatted_html': value['formatted_html'],
    };
}

